import { render, staticRenderFns } from "./TrainingTrends.vue?vue&type=template&id=21b09d3c&scoped=true&"
import script from "./TrainingTrends.vue?vue&type=script&lang=js&"
export * from "./TrainingTrends.vue?vue&type=script&lang=js&"
import style0 from "./TrainingTrends.vue?vue&type=style&index=0&id=21b09d3c&scoped=true&lang=css&"
import style1 from "./TrainingTrends.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b09d3c",
  null
  
)

export default component.exports